function polyDataTransferables(polyData) {
    return [
        polyData.points,
        polyData.vertices,
        polyData.lines,
        polyData.polygons,
        polyData.triangleStrips,
        polyData.pointData,
        polyData.cellData
    ];
}
export default polyDataTransferables;
//# sourceMappingURL=poly-data-transferables.js.map